<template>
  <div class="latest-news-page">
    <div class="news-box" v-if="loaded && allNews && allNews.length > 0">
      <visa-news-item
        v-for="news in allNews"
        :key="news.id"
        :news-info="news"
      ></visa-news-item>
    </div>
    <div class="video-list-null" v-if="loaded && allNews && allNews.length === 0">
      <img class="image" src="https://o.666visa.cn/static/ssqwxa/peer_shop/article-null.png" />
      <div class="text">暂无文章</div>
    </div>
    <div class="bottom-page-box" v-if="totalCount">
      <span class="total-count">共 {{ totalCount }} 条</span>
      <el-pagination
        class="page-box"
        @current-change="currentPageChange"
        :current-page="page"
        :page-size="countPerPage"
        layout="prev, pager, next"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import visaNewsItem from "./components/visa-news-item";
import knowledgeService from "../../services/knowledge-service";

export default {
  name: "latest-news-page",
  components: {
    visaNewsItem,
  },
  data() {
    return {
      allNews: [],
      totalCount: 0,
      countPerPage: 4,
      page: 1,
      loaded: false,
    };
  },
  methods: {

    currentPageChange(currentPage) {
      this.page = currentPage;
      this.getBriefLatestNews();
    },

    getBriefLatestNews() {
      knowledgeService
        .visaArticleBriefQuery({
          catalog_id: 2,
          per_page: this.countPerPage,
          page: this.page,
        })
        .then((data) => {
          this.totalCount = data.total_count;
          this.allNews = data.page_data;
          this.loaded = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getBriefLatestNews();
  },
};
</script>

<style lang="less" scoped>
.latest-news-page {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  .video-list-null {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 100px;
    .text {
      margin-top: 20px;
      font-size: 20px;
      color: #91999f;
    }
  }
  .bottom-page-box {
    margin-top: 48px;
    align-self: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .total-count {
      font-size: 16px;
      font-weight: 400;
      color: #5f666e;
      line-height: 16px;
    }
    .page-box {
      margin-left: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/LatestNews.vue